import { Record } from 'immutable'
import { softError } from 'lib/softError'

const selectors = {
  activeModal: state => state.modal
}

const types = [
  'SHOW_MODAL',
  'DISMISS_MODAL',
  'UPDATE_MODAL_PROPS'
].reduce((a, k) => ({ [k]: `modal/${k}`, ...a }), {})

const Modal = Record({
  type: null,
  props: {}
})

const reducer = (modalState = null, action = {}) => {
  switch (action.type) {
    case types.DISMISS_MODAL: {
      return null
    }
    case types.SHOW_MODAL: {
      const { modalType, props } = action
      return Modal({
        type: modalType,
        props
      })
    }
    case types.UPDATE_MODAL_PROPS: {
      const { type, props } = modalState
      const { nextProps } = action

      if (!type) {
        softError('you attempted to update modal props, but no modal is currently in state. showModal before you updateModalProps')
      }

      return Modal({
        type,
        props: Object.assign({ ...props, ...nextProps })
      })
    }
    default:
      return modalState
  }
}

const actions = {
  dismissModal: () => ({
    type: types.DISMISS_MODAL
  }),
  showModal: (modalType, props) => ({
    type: types.SHOW_MODAL,
    modalType,
    props
  }),
  updateModalProps: (nextProps) => ({
    type: types.UPDATE_MODAL_PROPS,
    nextProps
  })
}

export {
  actions as modalActions,
  types as modalTypes,
  reducer as modalReducer,
  selectors as modalSelectors
}
